// extracted by mini-css-extract-plugin
export default {"badge":"EnvBrandImage_badge__Wht40","wrap":"EnvBrandImage_wrap__6LbtR"};